import {AxiosInstance, AxiosResponse} from 'axios';
//types
import {
	IUserDonationResponse,
	IMakeDonationRequest,
	IMakeDonationResponse,
	IOrganizationMakeDonationRequest,
} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class UserDonationService {
	static makeDonation = async (
		reqBody: IMakeDonationRequest,
		apiInstance: AxiosInstance
	): Promise<AxiosResponse<IMakeDonationResponse>> =>
		apiInstance.post(API_URL.TABLES_AND_TICKETS_MAKE_DONATION, reqBody);

	static makeOrganizationDonation = async (
		reqBody: IOrganizationMakeDonationRequest,
		apiInstance: AxiosInstance
	): Promise<AxiosResponse<void>> => apiInstance.post(API_URL.DONATION, reqBody);

	static getDonationList = async (
		id: number,
		apiInstance: AxiosInstance
	): Promise<AxiosResponse<IUserDonationResponse>> => apiInstance.get(`${API_URL.EVENT_DONATION_LIST}/${id}`);
}

export {UserDonationService};
